import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { ReactComponent as DropdownIcon } from 'images/common/dropdown.svg'
import { ReactComponent as ActiveIcon } from 'images/checkbox/active.svg'
import { ReactComponent as InactiveIcon } from 'images/checkbox/inactive.svg'
import { searchGroupsData } from '../../../utils'
import styles from '../StationSelector.module.scss'
import { useStationGroups } from 'components/analytics/context/StationGroupsContext'
import { ReactComponent as LoadingIcon } from 'images/common/loading.svg'

const cx = classNames.bind(styles)

const GroupList = ({
  groups,
  value,
  search,
  handleDropdownItemClick
}) => {
  const { loading: groupsLoading, error: groupsError } = useStationGroups()

  const [activeParentGroup, setActiveParentGroup] = useState('')
    
  const groupsToDisplay = search ? searchGroupsData(groups, search) : groups

  const handleParentGroupClick = (parentGroupName) => {
    setActiveParentGroup(parentGroupName === activeParentGroup ? '' : parentGroupName)
  }

  const selectedGroupsCount = {};

  for (const groupSet of groups) {
    const { id, childGroups } = groupSet;
    // Collect all groupIds under this parentGroup
    const groupIds = childGroups.map(group => group.id);

    // Count how many of those groupIds are in the values array
    const count = groupIds.filter(id => value.includes(id)).length;

    selectedGroupsCount[id] = count;
  }

  return (
    <div className={`${cx('items-list')} ${cx('dropdown-wrapper')}`}>
      {groupsLoading && <div className={cx('loader-wrapper')}><LoadingIcon height={40} width={40} /></div>}

      {!groupsLoading && !groupsError && (
        groups.length > 0 ? (
          groupsToDisplay.map(group => (
            <div key={group.id}>
              {group.id !== 'all-stations' && <div
                className={cx('item', 'dropdown-parent', { 'selected': selectedGroupsCount[group.id] })}
                onClick={() => handleParentGroupClick(group.id)}
              >
                {group.name} {selectedGroupsCount[group.id] > 0 && '(' + selectedGroupsCount[group.id] + ')'}
                <DropdownIcon className={cx('dropdown-icon', { active: group.id === activeParentGroup || search })} />
              </div>}
              {(group.id === activeParentGroup || search || group.id === 'all-stations') && (
                <div className={cx('dropdown-child-wrapper')}>
                  {group.childGroups && group.childGroups.length > 0 ? (
                    group.childGroups.map(childGroup => (
                      <div
                        key={childGroup.id}
                        className={cx('item', 'dropdown-child', { 'no-indent': group.id === 'all-stations' })}
                        onClick={e => handleDropdownItemClick(e, childGroup.id)}
                        data-testid={group.id}
                      >
                        <div>
                          {childGroup.name}
                          <div className={cx('station-count')}>
                            {childGroup.stationGuids.length} stations
                          </div>
                        </div>
                        {value.includes(childGroup.id) ? (
                          <ActiveIcon />
                        ) : (
                          <InactiveIcon />
                        )}
                      </div>
                    ))
                  ) : (
                    <div className={cx('item', 'item-info')}>
                      No groups available
                    </div>
                  )}
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={cx('item', 'item-info')}>
            No groups available
          </div>
        )
      )}

      {groupsError && <div className={cx('item', 'item-info')}>
        Something went wrong when fetching groups. Please refresh and try again.
      </div>}
    </div>
  )
}

GroupList.propTypes = {
  groups: PropTypes.array.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  search: PropTypes.string,
  handleDropdownItemClick: PropTypes.func.isRequired
}

export default GroupList
